module.exports = __webpack_public_path__ + "static/media/seta_up.bb42dd06.svg";